import {
  Modal,
  TouchableWithoutFeedback,
  View,
  useWindowDimensions,
} from 'react-native'
import type { ModalProps } from 'react-native'

type SelectPortalProps = Pick<ModalProps, 'visible'> & {
  children?: React.ReactNode
  onOverlayPress?(): void
}

export function SelectPortal({
  children,
  onOverlayPress,
  ...props
}: SelectPortalProps) {
  const { width, height } = useWindowDimensions()

  return (
    <Modal {...props} statusBarTranslucent={false} transparent>
      <TouchableWithoutFeedback onPress={onOverlayPress}>
        <View
          style={{
            width,
            height,
            position: 'relative',
            backgroundColor: 'transparent',
          }}
        >
          {children}
        </View>
      </TouchableWithoutFeedback>
    </Modal>
  )
}
